import { gql } from "@apollo/client"
import { Connection, User } from "./UserQueries"


export type Template = {
  id: string
  version: number
  name: string
  folder: string
  order: number
  connectionId: string
  structureId: string
  locale: string
  timezone: string
  platform: string
  type: number
  derived: TemplateMeta
}

export type TemplateMeta = {
  reactSchema: JSON
}

export type TemplateVars = {
  id: string
}

export type TemplateData = {
  template: Template
}

export type Templates = {
  items: Template[]
  total: number
}

export enum TemplateScope { Mine, Favourite, Company, Partner, Public }

export type TemplatesData = {
  templates: Templates
}

export type TemplatesVars = {
  ids?: string[]
  search?: string
  folder?: string
  platform?: string
  scope?: TemplateScope
  connectionId?: string
  limit?: number
  page?: number
}

export const GET_TEMPLATE = gql`
query getTemplate($id: ObjectId!) {
  template(id: $id) { id version name folder order connectionId structureId locale timezone platform type derived { reactSchema }}
}
`

export const GET_TEMPLATES_SELECT = gql`
query getTemplates($ids: [ObjectId!], $search: String, $folder: ObjectId, $platform: String, $scope: String, $connectionId: ObjectId, $limit: Int, $page: Int) {
  templates(ids: $ids, search: $search, folder: $folder, platform: $platform, scope: $scope, connectionId: $connectionId, limit: $limit, page: $page) { total
    items { id name } }
}
`;